import type { CityConfig } from "../city-template/types";

export const plymouthConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — NH Dept of State Vital Records", href: "https://sos.nh.gov/vital-records/", description: "Official New Hampshire vital records office in Concord" },
    { label: "Marriage Licenses — Grafton County Clerk", href: "https://www.graftoncountynh.gov/", description: "Grafton County Clerk — marriage license issuance" },
    { label: "Divorce Records — Grafton County Superior Court", href: "https://www.courts.nh.gov/", description: "Grafton County Superior Court — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of NH SOS for online vital record orders" },
  ],
  city: "Plymouth",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "plymouth",
  route: "/cities/plymouth",
  title: "Emergency Passport Plymouth, NH | Fast Passport Renewal & White Mountains Expedited Help",
  metaDescription: "Emergency passport and expedited passport services in Plymouth, NH — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for White Mountains and Plymouth State University travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Plymouth, NH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Plymouth and White Mountains travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Plymouth%20New%20Hampshire%20scenic%20view%20with%20Plymouth%20State%20University%20campus%20buildings%2C%20Pemigewasset%20River%20flowing%20through%20the%20town%2C%20White%20Mountains%20in%20the%20background%20with%20dramatic%20peaks%2C%20New%20England%20autumn%20foliage%20with%20vibrant%20red%20and%20orange%20maple%20trees%2C%20charming%20small%20mountain%20town%20with%20historic%20architecture%2C%20warm%20golden%20hour%20light%2C%20clean%20photorealistic%20landscape%2C%20no%20visible%20text%20or%20people%2C%20warm%20earth%20tones%20and%20mountain%20blue%20sky%2C%20professional%20photography&width=1800&height=700&seq=plymouth-nh-hero-001&orientation=landscape",
  heroImageAlt: "Plymouth New Hampshire with Plymouth State University, Pemigewasset River and White Mountains backdrop",
  geoPosition: "43.7570;-71.6881",
  geoPlacename: "Plymouth, New Hampshire",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "10 Causeway St Suite 247, Boston, MA 02222",
    distance: "Approximately 120 miles, 2+ hours from Plymouth via I-93",
  },
  nearbyCitiesZips: [
    { name: "Plymouth", zips: "03264" },
    { name: "Holderness", zips: "03245" },
    { name: "Rumney", zips: "03266" },
    { name: "Ashland", zips: "03217" },
    { name: "Campton", zips: "03223" },
    { name: "Thornton", zips: "03285" },
    { name: "Waterville Valley", zips: "03215" },
    { name: "Lincoln", zips: "03251" },
    { name: "Woodstock", zips: "03262" },
    { name: "Warren", zips: "03279" },
    { name: "Hebron", zips: "03241" },
    { name: "Groton", zips: "03241" },
    { name: "Bristol", zips: "03222" },
    { name: "Alexandria", zips: "03222" },
    { name: "Bridgewater", zips: "03222" },
    { name: "New Hampton", zips: "03256" },
    { name: "Center Harbor", zips: "03226" },
    { name: "Meredith", zips: "03253" },
    { name: "Sanbornton", zips: "03269" },
    { name: "Tilton", zips: "03276" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent White Mountains and North Country departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Concord", route: "/concord-nh" },
    { name: "Manchester", route: "/manchester" },
    { name: "Nashua", route: "/cities/nashua" },
    { name: "Keene", route: "/cities/keene" },
    { name: "Lebanon", route: "/cities/lebanon" },
    { name: "Laconia", route: "/cities/laconia" },
    { name: "Dover", route: "/cities/dover" },
    { name: "Portsmouth", route: "/cities/portsmouth" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Plymouth remotely via secure courier. We do not have a walk-in office in Plymouth — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for White Mountains and North Country travelers.",
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeDistance: "Serving all of Grafton County and the White Mountains region",
  serviceAreaIntro: "From the Plymouth State University campus to the downtown Main Street area, from the Holderness border to the Rumney cliffs — Fast Passport Center serves the entire Plymouth community. We regularly help travelers from Holderness, Rumney, Ashland, and Campton get their passports fast.",
  nearbyCitiesIntro: "We serve all Plymouth neighborhoods and nearby White Mountains and North Country cities including Holderness, Rumney, Ashland, Campton, Thornton, Waterville Valley, Lincoln, Woodstock, Warren, Hebron, Groton, Bristol, Alexandria, Bridgewater, New Hampton, Center Harbor, Meredith, Sanbornton, and Tilton. If you are in the greater Plymouth area, we have you covered.",
  howItWorksIntro: "Most Plymouth travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency — especially important given the 2.5+ hour drive to Boston from the White Mountains.",
  mistakesIntro: "With Plymouth State University sending students abroad and the White Mountains drawing international tourists, Plymouth travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Plymouth and White Mountains travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Plymouth? Here are the most common ones we hear from White Mountains and North Country travelers.",
  statePageRoute: "/states/new-hampshire",
  statePageName: "New Hampshire",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Plymouth international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Emily S.",
      location: "Plymouth, NH",
      rating: 5,
      text: "My study abroad program to Ireland started in 5 days and my passport was expired. Fast Passport Center got it renewed in 2 days. Saved my semester!",
      service: "Emergency Passport",
    },
    {
      name: "Ryan K.",
      location: "Holderness, NH",
      rating: 5,
      text: "Needed to renew for a ski trip to the Alps. The process was smooth, they reviewed everything, and I had my passport in 4 days. Outstanding.",
      service: "Passport Renewal",
    },
    {
      name: "Laura M.",
      location: "Ashland, NH",
      rating: 5,
      text: "Lost my passport the week before my cruise. They walked me through the DS-64 process and got me a replacement in 48 hours. Amazing service.",
      service: "Lost Passport",
    },
    {
      name: "John D.",
      location: "Rumney, NH",
      rating: 5,
      text: "As a frequent international traveler from the White Mountains, I can't afford passport delays. Fast Passport Center has been my go-to for years. Always reliable.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "plymouth-nh-1",
      name: "Plymouth Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Main St",
      city: "Plymouth",
      state: "NH",
      zip: "03264",
      phone: "(603) 536-4740",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.2 miles from downtown Plymouth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Plymouth and Plymouth State University students. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "plymouth-nh-2",
      name: "Ashland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12 Main St",
      city: "Ashland",
      state: "NH",
      zip: "03217",
      phone: "(603) 968-3311",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "4.0 miles from Plymouth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Ashland and Squam Lake area residents. Limited hours — book appointments well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "plymouth-nh-3",
      name: "Campton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "25 Main St",
      city: "Campton",
      state: "NH",
      zip: "03223",
      phone: "(603) 726-4140",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "6.5 miles from Plymouth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves western Grafton County and the White Mountains Highway corridor. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "plymouth-nh-4",
      name: "Bristol Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Main St",
      city: "Bristol",
      state: "NH",
      zip: "03222",
      phone: "(603) 744-2714",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "8.0 miles from Plymouth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Newfound Lake area residents. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "plymouth-nh-5",
      name: "Tilton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10 Main St",
      city: "Tilton",
      state: "NH",
      zip: "03276",
      phone: "(603) 286-3330",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "10.5 miles from Plymouth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southern Grafton County and the Lakes Region. Limited hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "plymouth-nh-6",
      name: "Plymouth Town Clerk",
      type: "Town Clerk Passport Acceptance",
      address: "6 Post Office Sq",
      city: "Plymouth",
      state: "NH",
      zip: "03264",
      phone: "(603) 536-1738",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.1 miles from Town Hall",
      website: "https://www.plymouth-nh.org/",
      websiteLabel: "Plymouth Town Clerk",
      notes: "Major municipal facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Boston (2.5+ hrs)", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Plymouth photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Grafton County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Plymouth applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Plymouth families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Plymouth travelers often assume standard processing will be fine. It takes 6–13 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Plymouth." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Plymouth address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Plymouth before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Plymouth for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most White Mountains and North Country travelers." },
    { q: "How fast can I renew my passport in Plymouth?", a: "Fast Passport Center offers fast passport renewal in Plymouth in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. We can expedite your passport renewal in Plymouth in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Plymouth?", a: "Same-day passport appointments are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Plymouth residents." },
    { q: "Can I expedite a child passport in Plymouth?", a: "Yes. Fast Passport Center expedites child passports in Plymouth for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Plymouth with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Plymouth?", a: "With Fast Passport Center's emergency courier service, Plymouth travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to visit the Boston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change. This is especially important for Plymouth residents, as the Boston agency is a 2.5+ hour drive away." },
    { q: "Where are the closest passport acceptance facilities in Plymouth?", a: "Popular options include the Plymouth Post Office (03264), Ashland Post Office (03217), Campton Post Office (03223), Bristol Post Office (03222), and Plymouth Town Clerk (03264). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Plymouth?", a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option." },
    { q: "What if I live in a nearby town like Holderness or Rumney?", a: "We serve all of the White Mountains and North Country including Holderness, Rumney, Ashland, Campton, Thornton, Waterville Valley, Lincoln, Woodstock, Warren, Hebron, Groton, Bristol, New Hampton, Center Harbor, Meredith, and Tilton. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Plymouth?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Plymouth", address: "11 Main St, Plymouth, NH 03264", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Plymouth", address: "10 Main St, Plymouth, NH 03264", hours: "Mon–Sun: 7AM–11PM" },
    { name: "UPS Store — Plymouth", address: "1 Main St, Plymouth, NH 03264", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — Tilton", address: "30 Main St, Tilton, NH 03276", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Bristol", address: "5 Main St, Bristol, NH 03222", hours: "Mon–Sun: 8AM–10PM" },
    { name: "FedEx Office — Concord", address: "77 Fort Eddy Rd, Concord, NH 03301", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "Costco — Concord", address: "71 Interstate Dr, Concord, NH 03301", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM" },
    { name: "Walgreens — Laconia", address: "25 Main St, Laconia, NH 03246", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    { name: "DMV — Concord", address: "23 Hazen Dr, Concord, NH 03301", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID and driver's license renewals. Passport-ready photo services. Appointment required.", featured: true },
    { name: "DMV — Laconia", address: "15 Main St, Laconia, NH 03246", hours: "Mon–Fri: 8AM–5PM", note: "Passport-ready photo services available. Online appointment booking.", featured: false },
    { name: "DMV — Tilton", address: "11 E Main St, Tilton, NH 03276", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID processing. Walk-ins limited — book online first.", featured: false },
    { name: "DMV — Newport", address: "10 Main St, Newport, NH 03773", hours: "Mon–Fri: 8AM–5PM", note: "Full-service center for western New Hampshire residents.", featured: true },
  ],
  airports: [
    { code: "MHT", name: "Manchester-Boston Regional Airport", distance: "50 miles from Plymouth", address: "1 Airport Rd, Manchester, NH 03103", note: "Closest major commercial airport for Plymouth travelers. International flights to Canada and Europe. Major domestic hub.", flightUrl: "https://www.flymanchester.com/", flightLabel: "MHT Flight Info", featured: true },
    { code: "BOS", name: "Boston Logan International Airport", distance: "120 miles from Plymouth", address: "1 Harborside Dr, Boston, MA 02128", note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via I-93.", flightUrl: "https://www.massport.com/logan-airport", flightLabel: "Logan Airport", featured: false },
    { code: "CON", name: "Concord Municipal Airport", distance: "30 miles from Plymouth", address: "71 Airport Rd, Concord, NH 03301", note: "Regional airport for general aviation. Charter and private flights available.", flightUrl: "https://www.concordairport.org/", flightLabel: "Concord Airport", featured: false },
  ],
};